import { render, staticRenderFns } from "./guestMailMagazine.vue?vue&type=template&id=21dbccb4&scoped=true&lang=pug"
import script from "./guestMailMagazine.vue?vue&type=script&lang=js"
export * from "./guestMailMagazine.vue?vue&type=script&lang=js"
import style0 from "./guestMailMagazine.vue?vue&type=style&index=0&id=21dbccb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbccb4",
  null
  
)

export default component.exports